import React, { useEffect } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";

const HotelSearch = () => {

  // ------------------ CHECK-IN DATE ------------------
  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd-M-yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function () {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#dep_dayNum").text(day);
        $("#dep_monthYear").text(`${month}-${year}`);
        $("#dep_dayName").text(dayName);
      },
    });
  }, []);

  // ------------------ CHECK-OUT DATE ------------------
  useEffect(() => {
    $("#returnDate").datepicker({
      dateFormat: "dd-M-yy",
      appendTo: "#dateDisplay2",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay2").offset();
          const height = $("#dateDisplay2").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function () {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#ret_dayNum").text(day);
        $("#ret_monthYear").text(`${month}-${year}`);
        $("#ret_dayName").text(dayName);
      },
    });
  }, []);

  return (
    <>
      <div className="Hotl_serch">
        <div className="row">

          <div className="col-md-6 col-lg-6">
            <div className="d-flex">

              {/* Radio Buttons */}
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="BusinessTravel"
                    id="BusinessTravel"
                  />
                  <label className="form-check-label" htmlFor="BusinessTravel">
                    Business Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="PersonalTravel"
                    id="PersonalTravel"
                  />
                  <label className="form-check-label" htmlFor="PersonalTravel">
                    Personal Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="GuestTravel"
                    id="GuestTravel"
                  />
                  <label className="form-check-label" htmlFor="GuestTravel">
                    Guest Travel
                  </label>
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6 col-lg-6">
            <div className="theme_tx"></div>
          </div>

        </div>

        <div className="form_ful">

          {/* Destination */}
          <div className="Destnion">
            <p>
              <i className="fa fa-hotel"></i> Enter City Name, Location, or Specific Hotel
            </p>
            {/* <input className="form_control_hotel" type="text" defaultValue="" placeholder="Delhi"/> */}

            <div className="detinion">
              <input className="form_control_hotel" type="text" defaultValue="" placeholder="Enter City Name.."/>
              {/* <div className="dest_name">Delhi</div> */}
              {/* <p className="view_diply">India</p> */}
            </div>
          </div>

          {/* Check-In */}
          <div className="Destnion_date">
            <p><i className="fa fa-calendar-days"></i> Check-In</p>

            <div
              className="dest_nam"
              id="dateDisplay"
              onClick={() => $("#departureDate").datepicker("show")}
              style={{ cursor: "pointer" }}
            >
              <span id="dep_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>08</span>{" "}
              <span id="dep_monthYear" style={{ fontSize: "14px" }}>Oct-2025</span>
              <br />
              <span id="dep_dayName">Friday</span>

              <input
                type="text"
                id="departureDate"
                style={{ position: "absolute", left: "-9999px" }}
                readOnly
              />
            </div>
          </div>

          {/* Check-Out */}
          <div className="Destnion_date">
            <p><i className="fa fa-calendar-days"></i> Check-Out</p>

            <div
              className="dest_nam"
              id="dateDisplay2"
              onClick={() => $("#returnDate").datepicker("show")}
              style={{ cursor: "pointer" }}
            >
              <span id="ret_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>08</span>{" "}
              <span id="ret_monthYear" style={{ fontSize: "14px" }}>Oct-2025</span>
              <br />
              <span id="ret_dayName">Friday</span>

              <input
                type="text"
                id="returnDate"
                style={{ position: "absolute", left: "-9999px" }}
                readOnly
              />
            </div>
          </div>

          {/* Rooms & Guests */}
          <div className="Rooms_Guests showSelect">
            <p><i className="fa fa-users"></i> Rooms & Guests</p>

            <div className="pax_no">
              <div className="Adlt_pax">1 <span>Room</span></div>
              <div className="Adlt_pax">2 <span>Guests</span></div>
              <img src="/assets/images/down.png" className="down" alt="flight" />
            </div>
            <div className="traveller-calulate-persons">
              <div className="se_l_d-flex">
                <div className="d-flex-lft"></div>
                <div className="d-flex-rgt"></div>
              </div>
            </div>

            {/* Dropdown */}
            <div className="hotel dropdown_passenger_info" id="toggle_dropdown">

              <div className="traveller-calulate-persons">

                {/* ROOM 1 */}
                <div className="passengers">
                  <h6>Room 1:</h6>

                  <div className="passengers-types">

                    {/* Adults */}
                    <div className="passengers-type">
                      <div className="text">
                        <div className="type-label">
                          <p>Adult</p>
                          <span>12+ yrs</span>
                        </div>
                      </div>

                      <div className="button-set">
                        <select className="form-select form-select-solid">
                          <option value="1" defaultChecked>1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                        </select>
                      </div>
                    </div>

                    {/* Children */}
                    <div className="passengers-type">
                      <div className="text">
                        <div className="type-label">
                          <p>Children</p>
                          <span>2 - Less than 12 yrs</span>
                        </div>
                      </div>

                      <div className="button-set">
                        <select className="form-select form-select-solid">
                          <option value="0" defaultChecked>0</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                        </select>
                      </div>
                    </div>

                  </div>
                </div>

                {/* FOOTER BUTTONS
                <div className="col-md-12 d-flex">
                  <a href="/" className="click-to-add-room">Add Room</a>
                  <a href="/" className="click-to-remove-room">Remove Room</a>
                  <a href="/" className="done_selct">Done</a>
                </div> */}

              </div>
            </div>
          </div>

          {/* SEARCH BUTTON */}
          <div className="Rooms_Guests_Serch">
            <a className="Serch" href="/">Raise Request</a>
          </div>

        </div>
      </div>
    </>
  );
};

export default HotelSearch;
